import { useCallback, useState, useRef } from 'react';
import { Button, ButtonSize, ButtonThemes, MyLink } from '@app/shared';
import { pathToBrandCatalog } from '@app/shared/helpers';
import { useWindowSizing } from '@hooks/useSizeWindow';
import { useAppSelector } from '@redux/hooks';
import { BrandTableTypeProps } from './TypeProps';
import classNames from 'classnames';
import Image from 'next/image';
import IconArrow from './icons/Arrow.svg';
import config from '@app/config';

import styles from './BrandTable.module.scss';

const NO_PHOTO: string = '/next/img/nophoto.png';

export const BrandTable = ({ className, brands, type }: BrandTableTypeProps) => {
  const isMobile = useWindowSizing(550);
  const host = useAppSelector(state => state.header.data.host);
  const [showAll, setShowAll] = useState<boolean>(false);

  const contentRef = useRef(null);
  const sliceCount = isMobile ? 12 : 21;

  const raiseWindow = () => {
    setTimeout(() => {
      contentRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }, 300);
  };

  const handleShow = useCallback(() => {
    setShowAll(!showAll);
    if (showAll) {
      raiseWindow();
    }
  }, [showAll]);

  return (
    <div className={classNames(styles.WrapperBrandTable, { [styles.showAll]: showAll }, className)}>
      <div className={styles.Container} ref={contentRef}>
        {brands?.slice(0, showAll ? brands?.length : sliceCount)?.map(brand => {
          const path = pathToBrandCatalog(type, brand?.urlname);
          return (
            <MyLink reloaded className={styles.Item} key={brand?.urlname} href={`${host}${path}`} data-testid={`brand-table-${path}`}>
              <BrandTable.BrandTableImage brand={brand} />
            </MyLink>
          );
        })}
      </div>
      {brands?.length > sliceCount && (
        <Button size={ButtonSize.S} themes={ButtonThemes.BlackSecondary} onClick={handleShow} data-testid="catalog-brands-btn-show-more">
          {showAll ? 'Только популярные' : 'Показать еще'}
          <IconArrow width={11} height={14} />
        </Button>
      )}
    </div>
  );
};

BrandTable.BrandTableImage = function BrandTableImage({ brand }) {
  const [srcImage, setSrcImage] = useState<string>(`${config.baseImageUrl}/${brand?.thumb}`);
  const [isNoPhoto, setIsNoPhoto] = useState<boolean>(false);

  const handleError = () => {
    setSrcImage(NO_PHOTO);
    setIsNoPhoto(true);
  };

  return (
    <div className={styles.BrandFallback}>
      <Image src={srcImage} alt={brand?.name} width={110} height={isNoPhoto ? 45 : 28.21} layout={'fixed'} onError={handleError} />
      {isNoPhoto && <span>{brand.name}</span>}
    </div>
  );
};
